// lib
import React, { useState, useRef, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'

import ADND from '@aytm/lib/adnd/ADND'

// components
import Popup from '@aytm/lib/rfd-ui/components/basic/popup'
import SidebarPopup from '@aytm/app/stats/page/sidebar/components/SidebarPopup'

// styles
import style from '@aytm/app/stats/page/sidebar/components/styles/CustomQuestion.module.scss'

const CustomQuestionButton = ({
  root,
  item,
  features,
  windowUID,
  disabled,
  addCustomQuestion,
  onDNDStart,
  onDNDEnd
}) => {
  const [blocked, setBlocked] = useState(false)

  const timer = useRef(null)

  const dndListItemRef = useRef()

  const createCustomQuestion = useCallback(() => Object.assign({}, item.default), [item])

  const onClick = useCallback(() => {
    setBlocked(true)

    const question = createCustomQuestion()
    addCustomQuestion(question)

    timer.current && clearTimeout(timer.current)
    timer.current = setTimeout(() => setBlocked(false), 1000)

    return () => timer.current && clearTimeout(timer.current)
  }, [addCustomQuestion, createCustomQuestion])

  const dndListItem =
    disabled || features[item.feature].disabled
      ? null
      : ADND.sources
          .data({
            type: `question-custom-${windowUID}`,
            clearDragImage: false
          })
          .onStart(onDNDStart)
          .onEnd(onDNDEnd)
          .fetchData(createCustomQuestion)

  useEffect(() => {
    if (dndListItem) dndListItem.connect(dndListItemRef.current)

    return () => {
      if (dndListItem) dndListItem.disconnect()
    }
  }, [dndListItem])

  return (
    <div ref={dndListItemRef} className={`${style.row} p-fluid`}>
      {disabled ? (
        <div className={`${style.button} p-disabled`}>
          <span className={style['button-text']}>
            {item.icon ? <i className={`icon-aytmfd-${item.icon}`} /> : null}
            {item.text}
          </span>
          <span className={style['button-lock-icon']}>
            <i className="icon-aytmfd-lock" />
          </span>
        </div>
      ) : features[item.feature].available ? (
        <Popup
          targetClassName="p-field p-col-12"
          width="254px"
          trigger="hover"
          direction="topleft"
          content={() => (
            <div>
              <p>
                {/* PME2 (AYTM-11321): render server-authored `text` verbatim; guard the icon, which
                    the already-on-Enterprise Contact-Us variant omits. */}
                {features[item.feature].onPackage.icon ? (
                  <span className={`stat-upgrade-icon stat-upgrade-icon-${features[item.feature].onPackage.id}`}>
                    <i className={`icon-aytmfd-${features[item.feature].onPackage.icon}`} />
                  </span>
                ) : null}
                <span dangerouslySetInnerHTML={{ __html: features[item.feature].onPackage.text }} />
              </p>
            </div>
          )}
        >
          <a className={style.button} href={features[item.feature].onPackage.upgradeURL} rel="noreferrer">
            <span className={style['button-text']}>
              {item.icon ? <i className={`icon-aytmfd-${item.icon}`} /> : null}
              <span dangerouslySetInnerHTML={{ __html: item.text }}></span>
            </span>
            <span className={style['button-lock-icon']}>
              <i className="icon-aytmfd-lock" />
            </span>
          </a>
        </Popup>
      ) : features[item.feature].disabled ? (
        <Popup
          targetClassName="p-field p-col-12"
          width="254px"
          trigger="hover"
          direction="topleft"
          content={() => (
            <div>
              <p>
                PLEASE LOGIN/JOIN THE TEAM TO UNLOCK ALL FEATURES <br />
                OF THE STAT REPORT
              </p>
            </div>
          )}
        >
          <div className={style.button}>
            <span className={style['button-text']}>
              {item.icon ? <i className={`icon-aytmfd-${item.icon}`} /> : null}
              {item.text}
            </span>
            <span className={style['button-lock-icon']}>
              <i className="icon-aytmfd-lock" />
            </span>
          </div>
        </Popup>
      ) : (
        <div className={style.button} onClick={blocked ? null : onClick}>
          <span className={style['button-text']}>
            {item.icon ? <i className={`icon-aytmfd-${item.icon}`} /> : null}
            {item.text}
          </span>
          <span className={style['button-handle']}>
            <i className="icon-aytmfd-handle" />
          </span>
        </div>
      )}
      {0 < item.help.length ? <SidebarPopup root={root} help={item.help} width="300px" /> : null}
    </div>
  )
}

CustomQuestionButton.propTypes = {
  root: PropTypes.any,
  item: PropTypes.object,
  features: PropTypes.object,
  windowUID: PropTypes.string,
  disabled: PropTypes.bool,
  addCustomQuestion: PropTypes.func,
  onDNDStart: PropTypes.func,
  onDNDEnd: PropTypes.func
}

CustomQuestionButton.displayName = 'CustomQuestionButton'

export default CustomQuestionButton

ADND().connect()
